{{ count() | number: '1.0-0' }}
